import React, { useEffect } from "react";
import Page from "../../../components/general/page";
import NewAccountingYearPage from "../../../components/accountingYear/createNewAccountYear";
import { useSelector } from "react-redux";
import { useIntl } from "react-intl";
import { useLocation, useNavigate } from "react-router-dom";

const NewAccountingYearView = ({pageRef}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const main = useSelector(state => state.main);
  const company = useSelector(state => state.company);
  const intl = useIntl();

  const selectedCompanyName = company?.companies?.find(el => el.id === main.clientIdSelected);

  useEffect(() => {
    if (!main?.clientIdSelected) return;
    // se cambio l'utente e redirigo su lista perché potrebbe avere degli esercizi
    if (!location?.state?.isEmptyList){
      navigate("/accounting-years-list");
    } else {
      navigate("/new-accounting-year", {state: {isEmptyList: false}});
    }
  }, [main?.clientIdSelected]);
  
  return (
    <Page
      pageRef={pageRef}
      title={intl.formatMessage({ id: "accountingYear.title" })}
      subtitle={
        selectedCompanyName?.ragioneSociale + " / " + intl.formatMessage({ id: "generic.fiscalCodeAbbreviation" }) + " " + main.companySelected
      }
      className={"contentStructure transparent"}
      subClassName="pageCss"   
    >
      <NewAccountingYearPage companyName={selectedCompanyName?.ragioneSociale}/>
    </Page>
  );
};

export default NewAccountingYearView;